export type Step = 'provider' | 'registration' | 'payment' | 'thanks' | 'interests' | 'newsletters' | 'recover' | 'check-inbox';
export type RegistrationType = "signup" | "login" | "external_profile" | "recover" | "check-inbox";
export type ErrorType = "signup" | "login" | "profile_completion" | "interests" | "newsletters";
export interface FormEvent {
  email: string,
  password?: string,
  full_name?: string,
  occupation?: string,
  years_of_experience?: string,
  country_code?: string,
  consent?: boolean,
  subscribed_at?: string,
  token?: string,
}

export interface LoginEvent extends FormEvent {
  email: string,
  password: string,
}

export interface CreateUserEvent extends FormEvent {
  email: string,
  full_name: string,
  occupation: string,
  years_of_experience: string,
  country_code: string,
  password: string,
  token: string,
}

export interface ExternalProfileEvent {
  "user[full_name]": string,
  "user[ocupation]": string,
  uid: string,
  provider: string,
  app_id: string,
  callback: string,
  authenticity_token: string
}

export interface Interest {
  type: string;
  name: string;
  slug: string;
  image: string;
}

export interface InterestResponse {
  interests: Interest[];
}

export interface NotificationsInterestsInfo {
  id: number;
  name: string;
  slug: string;
  description: string;
  image: string;
  original_id: string;
  category: string;
  status: string;
  created_at: string;
}

export interface NotificationsInterestFollow {
  id: number;
  follower_id: number;
  following: Following;
  created_at: string;
}

export interface Following {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
  quantity: number;
}

export interface Newsletter {
  id: string;
  name: string;
  description: string;
}

export interface gtmEvent {
  category: string;
  action: string;
  label: string;
  /**
   * Close reason (overlay_click, close_button, login, subscribed_to_newsletters, remind_me_later)
   */
  dim1: string;
  /**
   * Current step (provider, registration, payment, thanks, interests, newsletters)
   */
  dim2: string;
  /**
   * Registration type (login, signup)
   */
  dim3: string;
  /**
   * User email
   */
  dim4: string;
  /**
   * Has payment details
   */
  dim5: boolean;
  /**
   * Period (monthly/yearly)
   */
  dim6: string;
  /**
   * Plan name
   */
  dim7: string;
  /**
   * Experience ID
   */
  dim8: string;
  /**
   * Event source (navbar, gallery_regwall, gallery_paywall, project_regwall, article_paywall)
   */
  dim9: string;
  /**
   * Provider (Google, Facebook or Email)
   */
  dim10: string;
}

export const newsletters: Newsletter[] = [
  {
    id: '10ece817ce',
    name: 'Daily Update',
    description: 'Curated projects, architecture news and articles in your inbox.'
  },
  {
    id: 'f16e1b88ac',
    name: 'The Weekly Brief',
    description: 'Mapping the week in architecture: the best stories, projects, and creative sparks.'
  },
  {
    id: '3f454f649d',
    name: 'Products & Materials',
    description: 'Inspiring products for your future projects.'
  },
  {
    id: 'd036cda47c',
    name: 'ArchDaily Monthly Topic',
    description: "Curated deep-dives into the trends, challenges, and ideas shaping architecture today."
  },
  {
    id: '73ac59f885',
    name: 'Breaking News',
    description: 'Important news, events, and announcements in architecture.'
  },
  {
    id: 'edc78acd61',
    name: 'The ArchDaily Edit',
    description: 'Your backstage pass to architecture: Opinion-led, team insights, and exclusive curation — only for subscribers.'
  }
];

export const YEARS_OF_EXPERIENCE_OPTIONS = [
  "up_to_2_years",
  "2_to_5_years",
  "5_to_10_years",
  "more_years"
];

export interface FullUser {
  id: number,
  email: string,
  jwt_token: string,
  subscription: string,
  full_name: string,
  about_me: string | null,
  avatar: string | null,
  country: string | null,
  ocupation: string,
  years_of_experience: string,
  website: string | null,
  facebook: string | null,
  twitter: string | null,
  instagram: string | null,
  pinterest: string | null,
  birth_date: string | null,
  confirmed_at: string | null,
  legacy_confirmed: boolean,
  updated_at: number,
  accepted_at: string,
  notified: boolean
}

export interface PianoTerm {
  termId: string,
  name: string,
  resource: {
    name: string,
  },
  multiSeatCount?: number,
  /**
   * Original value, without discount
   */
  description: string,
  chargeCurrency: string,
  billingPlanTable: {
    period: "year" | "month",
    priceValue: number
  }[]
}

export interface PianoTermEvent {
  termId: string,
  offerId: string,
  term: PianoTerm
}

export interface CountryOptions {
  [key: string]: Record<string, string>
}

export const HOMEPAGE_URLS = {
  "us": "https://www.archdaily.com",
  "cl": "https://www.archdaily.cl",
  "br": "https://www.archdaily.com.br",
  "mx": "https://www.archdaily.mx",
  "co": "https://www.archdaily.co",
  "pe": "https://www.archdaily.pe",
  "cn": "https://www.archdaily.cn",
}
